import { useMemo } from "react";
import {
  useGetSectionRoleQuery,
  useGetSectionRolesQuery,
} from "./sectionRoleEndpoints";
import { SectionRole } from "../../entities/sectionRole";

/**
 * @param sectionRoleID
 */
export function useSectionRole(sectionRoleID: number | undefined) {
  const sectionRoleQuery = useGetSectionRoleQuery(sectionRoleID ?? 0, {
    skip: (sectionRoleID ?? 0) <= 0,
  });
  const sectionRoleEntity = sectionRoleQuery.data;

  return useMemo(() => {
    const ret: typeof sectionRoleQuery & {
      sectionRole?: SectionRole | undefined;
    } = {
      ...sectionRoleQuery,
    };
    if (sectionRoleEntity) ret.sectionRole = new SectionRole(sectionRoleEntity);
    return ret;
  }, [sectionRoleQuery, sectionRoleEntity]);
}

/**
 * @param opt
 * @param opt.skip
 */
export function useSectionRoles(opt?: { skip: boolean }) {
  const sectionRoleQuery = useGetSectionRolesQuery(undefined, opt);
  const sectionRoleEntitiesMap = sectionRoleQuery.data?.entities;

  return useMemo(() => {
    const ret: typeof sectionRoleQuery & {
      sectionRoles?: SectionRole[];
      sectionRolesMap?: { [id: number]: SectionRole };
    } = {
      ...sectionRoleQuery,
      sectionRoles: [],
      sectionRolesMap: {},
    };
    if (sectionRoleEntitiesMap) {
      const sectionRoles = [];
      const sectionRolesMap: any = {};

      for (const key in sectionRoleEntitiesMap) {
        if (Object.prototype.hasOwnProperty.call(sectionRoleEntitiesMap, key)) {
          const c = sectionRoleEntitiesMap[key];
          if (c) {
            const sectionRole = new SectionRole(c);
            sectionRoles.push(sectionRole);
            sectionRolesMap[sectionRole.id!] = sectionRole;
          }
        }
      }
      sectionRoles.sort((a, b) => (a.position ?? 0) - (b.position ?? 0));
      ret.sectionRoles = sectionRoles;
      ret.sectionRolesMap = sectionRolesMap;
    }

    return ret;
  }, [sectionRoleQuery, sectionRoleEntitiesMap]);
}
